<template>
  <el-drawer
    :title="title"
    :visible.sync="show"
    direction="rtl"
    size="520px"
    :append-to-body="true">
    <div class="agr-log-body" v-loading="loading">
      <el-timeline v-if="logs.length">
        <el-timeline-item
          v-for="log in logs"
          :key="log.id"
          :timestamp="log.createTime"
          placement="top"
          :type="dotType(log.action)">
          <div class="agr-log-item">
            <div class="agr-log-head">
              <el-tag size="mini" :type="tagType(log.action)">{{ log.action }}</el-tag>
              <span class="agr-log-op">{{ log.operator || '系统' }}</span>
            </div>
            <div v-if="log.oldValue" class="agr-log-row">
              <span class="agr-log-label">原文件：</span>
              <a :href="full(log.oldValue)" target="_blank">{{ shortName(log.oldValue) }}</a>
            </div>
            <div v-if="log.newValue" class="agr-log-row">
              <span class="agr-log-label">现文件：</span>
              <a :href="full(log.newValue)" target="_blank">{{ shortName(log.newValue) }}</a>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
      <el-empty v-else description="暂无签约文件变更记录"></el-empty>
    </div>
  </el-drawer>
</template>

<script>
import { agreementLogApi } from '@/api/api'

export default {
  name: 'AgreementChangeLogDrawer',
  props: {
    visible: { type: Boolean, default: false },
    bizType: { type: String, default: '' },
    bizId: { type: [Number, String], default: null },
    title: { type: String, default: '签约文件变更记录' }
  },
  data () {
    return {
      logs: [],
      loading: false
    }
  },
  computed: {
    show: {
      get () { return this.visible },
      set (v) { this.$emit('update:visible', v) }
    }
  },
  watch: {
    visible (v) {
      if (v && this.bizId != null) this.load()
    }
  },
  methods: {
    load () {
      this.loading = true
      agreementLogApi.list(this.bizType, this.bizId).then(res => {
        this.logs = res.data || []
      }).catch(() => {
        this.logs = []
      }).finally(() => {
        this.loading = false
      })
    },
    full (url) {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      return 'https://chb.bjzkbh.com' + (url.startsWith('/') ? url : '/' + url)
    },
    shortName (url) {
      if (!url) return ''
      const parts = url.split('/')
      return parts[parts.length - 1] || url
    },
    tagType (action) {
      if (action === '新增') return 'success'
      if (action === '删除') return 'danger'
      return 'warning'
    },
    dotType (action) {
      if (action === '新增') return 'success'
      if (action === '删除') return 'danger'
      return 'warning'
    }
  }
}
</script>

<style scoped>
.agr-log-body {
  padding: 16px 24px;
  height: calc(100vh - 80px);
  overflow-y: auto;
}
.agr-log-item {
  background: #fafafa;
  border-radius: 6px;
  padding: 10px 12px;
}
.agr-log-head {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.agr-log-op {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
.agr-log-row {
  font-size: 13px;
  line-height: 22px;
  word-break: break-all;
}
.agr-log-label {
  color: #606266;
}
</style>
